import i18n from 'i18next';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';
import 'dayjs/locale/en';
import { TIME_ZONE_DEFAULT } from '@/config';

export const dayDic = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
];

dayjs.extend(isBetween);
dayjs.extend(utc);
dayjs.extend(timezone);

const convertToTimeZone = (date) =>
  dayjs(date)
    .tz(TIME_ZONE_DEFAULT)
    .locale(i18n.language === 'es' ? 'es-mx' : 'en');

const formatUTCDate = (utcDate, format) => {
  if (utcDate) {
    return convertToTimeZone(utcDate).format(format);
  }
  return i18n.t('checkout.global.noDate');
};

const formatDateRange = (start_date, end_date) => {
  const startDate = convertToTimeZone(start_date);
  const endDate = convertToTimeZone(end_date);
  const diff = endDate.diff(startDate, 'day');
  return diff > 0
    ? i18n.t('checkout.global.rangeTime', {
      startTime: startDate
        .format('h:mm a')
        .replace('am', 'a.m.')
        .replace('pm', 'p.m.'),
      endTime: endDate
        .format('DD MMM, hh:mm a')
        .replace('am', 'a.m.')
        .replace('pm', 'p.m.'),
    })
    : i18n.t('checkout.global.rangeTimeOneDay', {
      startTime: startDate.format('h:mm a'),
      endTime: endDate.format('h:mm a'),
    });
};

const formatLocalDate = (date, options) => {
  const {
    day = 'D',
    dayName = 'dddd',
    month = 'MMMM',
    year = '',
    time = '',
    separator = ', ',
  } = options || {};
  if (i18n.language === 'es') {
    return formatUTCDate(
      date,
      `${dayName ? dayName + ', ' : ''}${day} [de] ${month}${year ? ' [de] ' + year : ''
      }${time ? ' ' + time : ''}`,
    );
  }

  return formatUTCDate(
    date,
    `${dayName ? dayNam + ', ' : ''}${month} ${day}${year ? ', ' + year : ''}${time ? ' ' + time : ''
    }`,
  );
};

const formatLocalDateShort = (date, options) => {
  const { day = 'DD', month = 'MM', year = 'YYYY', time = '' } = options || {};
  if (i18n.language === 'es') {
    return formatUTCDate(
      date,
      `${day}/${month}/${year}${time ? ' ' + time : ''}`,
    );
  }
  return formatUTCDate(
    date,
    `${month}/${day}${year}${time ? '  ' + time : ''}`,
  );
};

const isToday = (start_at, end_at) => {
  const startDate = convertToTimeZone(start_at);
  const endDate = convertToTimeZone(end_at);
  return dayjs().isBetween(startDate, endDate);
};

const isNext = (start_at) => {
  const startDate = convertToTimeZone(start_at);
  return dayjs().isBefore(startDate);
};

const isEnded = (endDate) => {
  return dayjs().isAfter(convertToTimeZone(endDate));
};

// create a function to get hours from utc 2025-09-20T00:01:00Z return the hh:mm format with es-mx time zone
const getHours = (utcDate) => {
  if (utcDate) {
    return convertToTimeZone(utcDate)
      .format('h:mm a')
      .replace('am ', 'a.m.')
      .replace('pm', 'p.m.');
  }
};

const formatDateRangeFull = (start_date, end_date) => {
  const startDate = convertToTimeZone(start_date);
  const endDate = convertToTimeZone(end_date);

  if (i18n.language === 'es') {
    return `${startDate.format('D')} y ${endDate.format(
      'D [de] MMMM [de] YYYY',
    )} `;
  }

  return `${startDate.format('D')} - ${endDate.format('MMMM D, YYYY')} `;
};

const formatDateRangeShort = (start_date, end_date) => {
  const startDate = convertToTimeZone(start_date);
  const endDate = convertToTimeZone(end_date);
  const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const getShortDay = (date) => date.format('dddd').slice(0, 3);

  return `${capitalize(getShortDay(startDate))} · ${startDate.format(
    'h:mm a',
  )} al ${capitalize(getShortDay(endDate))} · ${endDate.format('h:mm a')} `;
};

export {
  formatUTCDate,
  formatDateRange,
  formatLocalDate,
  formatLocalDateShort,
  convertToTimeZone,
  getHours,
  formatDateRangeFull,
  formatDateRangeShort,
  isToday,
  isNext,
  isEnded,
};
